import React from 'react';

import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {GameCenterHeaderModuleSeriesIndication} from "./game-center-header-module.series-indication";
import {GameCenterHeaderModuleDetails} from "./details/game-center-header-module.details";
import {GameCenterHeaderModuleSpread} from "./game-center-header-module.spread";
import {GameCenterHeaderModuleWinDescription} from "./game-center-header-module.win-description";
import styles from "../styles/game-center-header.module.scss";
import classNames from "classnames";
import {GameCenterHeaderModuleDescription} from "./game-center-header-module.description";
import {StarSelection} from "../../../../../core/components/entity-selection/star-selection";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";
import {APP} from "../../../../../core/app/consts";

export class GameCenterHeaderModuleContentProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleContent = ({controller}: GameCenterHeaderModuleContentProps) => {
  const {state} = controller;
  const {aggregateScore, winDescription, id, currentLinkModel} = state;

  const starIconProps = {
    id: id,
    type: PartialGameViewModel.name,
    source: APP.ANALYTICS.SOURCES[currentLinkModel?.name]
  }

  const bottomRectangleProps = {
    controller: controller,
    className: classNames(styles.description, {[styles.win_description]: !(aggregateScore && !winDescription)})
  }

  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.star)}>
        <StarSelection {...starIconProps}/>
      </div>
      <GameCenterHeaderModuleDescription controller={controller}/>
      <GameCenterHeaderModuleSeriesIndication controller={controller}/>
      <GameCenterHeaderModuleDetails controller={controller}/>
      <GameCenterHeaderModuleSpread {...bottomRectangleProps}/>
      <GameCenterHeaderModuleWinDescription {...bottomRectangleProps}/>
    </div>
  )
};
